import { lazy, Suspense } from 'react';

import { Loading } from '../../components/ui.jsx';

/**
 * Billing automation in the web app: billable items, the automation status page, and the
 * "Billable items" tab of the admin client page. UpgradePanel and CancellationForm (pages.jsx) are
 * there for the service page.
 */
const pages = () => import('./pages.jsx');
const page = (name) => () => pages().then((m) => ({ Component: m[name] }));
const Tab = lazy(() => pages().then((m) => ({ default: m.BillableItemsTab })));

function BillableItemsTab(props) {
  return (
    <Suspense fallback={<Loading />}>
      <Tab {...props} />
    </Suspense>
  );
}

export default {
  name: 'billing',
  adminRoutes: [
    { path: 'billing/billable-items', lazy: page('AdminBillableItems') },
    { path: 'billing/automation', lazy: page('AdminAutomation') },
  ],
  adminNav: [
    {
      section: 'billing',
      to: '/admin/billing/billable-items',
      label: 'Billable items',
      permission: 'admin.billable_items.manage',
      order: 40,
    },
    {
      section: 'billing_settings',
      to: '/admin/billing/automation',
      label: 'Automation',
      permission: 'admin.jobs.read',
      order: 50,
    },
  ],
  adminClientTabs: [
    {
      key: 'billable-items',
      label: 'Billable items',
      order: 33,
      permission: 'admin.billable_items.manage',
      Component: BillableItemsTab,
    },
  ],
};
